/*
 *  This has been generated using the Synergy STDev tool.
 *  Any modifications will be lost after the next build
 */
import * as sis from './SISApp'
import { componentApi, loadTranslations } from 'common'


export class K12IncidentSummaryApi {
  async LoadSummary(incidentGU : string, viewId : string) : Promise<sis.SchoolIncidentSummaryData> {
    return await componentApi.call('sis', 'k12-incident-summary', 'K12IncidentSummaryApi', 'LoadSummary', {
      incidentGU,
      viewId,
    });
  }
}
export default new K12IncidentSummaryApi()
